export default "__VITE_ASSET__CdcxkEsp__"